export default __webpack_public_path__ + "static/media/ilimoittautuminen_mobiili.aeb46a76.png";